import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure, USER_ROLE } from '@ptl/account-management';
import { BrandingConfigurationService } from '@ptl/brand';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { environment } from 'src/environments/environment';
import { Prospect } from '../../../interfaces/on-exchange-prospects-retrieval.producer.response.interface';
import { FFMRedirectService } from '../../../services/ffmredirect.service';
import { ProspectService } from '../../../services/prospect.service';
import { WYOnExchangeStatusTeamsite, NDOnExchangeStatusTeamsite } from './jsonContent/onExchangeStatus';
import { WYCompletedApplicationsTeamsite, NDCompletedApplicationsTeamsite } from './jsonContent/completed-applications';
import { WYExpiredApplicationsTeamsite, NDExpiredApplicationsTeamsite } from './jsonContent/expired-applications';
import { WYArchivedApplicationsTeamsite, NDArchivedApplicationsTeamsite } from './jsonContent/archived-applications';
import { WYEmailedApplicationsTeamsite, NDEmailedApplicationsTeamsite } from './jsonContent/emailed-applications';

// const PRODUCER_APPLICATION_CARD_ON_EXCHANGE_CONTENT = 'PRODUCER_APPLICATION_CARD_ON_EXCHANGE_CONTENT';
// enum PRODUCER_APPLICATION_CARD_ON_EXCHANGE_CONTENT_KEYS = {
//   'PAYMENT_LINK'
// }
@Component({
    selector: 'app-application-card-on-exchange',
    templateUrl: './application-card-on-exchange.component.html',
    styleUrls: ['./application-card-on-exchange.component.scss'],
    standalone: false
})
export class ApplicationCardOnExchangeComponent implements OnInit {
  @Input() prospect: Prospect;
  @Output() viewResults = new EventEmitter();
  @Output() makePayment = new EventEmitter();
  @Output() moreInfo = new EventEmitter();
  @Output() expire = new EventEmitter();

  teamsite: {
    inProgressApplications: any;
    completedApplications: any;
    expiredApplications: any;
    archivedApplications: any;
    emailedApplications: any;
  } = {
      inProgressApplications: null,
      completedApplications: null,
      expiredApplications: null,
      archivedApplications: null,
      emailedApplications: null
    };

  exchangeStatusNextSteps: string;
  showPaymentInfo: boolean;
  disableButtons: boolean;
  buttonVisibility = {
    editInfo: false, // portal edit
    goToMarketplace: false, // Back to CMS
    goToEligibilityStatus: false, // send to eligibility-status
    goToReviewPage: false,
    moreInfo: false,
    summary: false,
    makePayment: false,
    expire: false
  };

  constructor(
    private ffmRedirectService: FFMRedirectService,
    private reducerUtilityService: ReducerUtilityService,
    private prospectService: ProspectService
  ) { }

  get firstName() {
    return this.prospect.firstName.toUpperCase();
  }
  get lastName() {
    return this.prospect.lastName.toUpperCase();
  }
  ngOnInit(): void {
    if (environment.initData.brand.ASPID === 'WY') {
      this.teamsite = {
        inProgressApplications: WYOnExchangeStatusTeamsite,
        completedApplications: WYCompletedApplicationsTeamsite,
        expiredApplications: WYExpiredApplicationsTeamsite,
        archivedApplications: WYArchivedApplicationsTeamsite,
        emailedApplications: WYEmailedApplicationsTeamsite
      };
    } else if (environment.initData.brand.ASPID === 'ND') {
      this.teamsite = {
        inProgressApplications: NDOnExchangeStatusTeamsite,
        completedApplications: NDCompletedApplicationsTeamsite,
        expiredApplications: NDExpiredApplicationsTeamsite,
        archivedApplications: NDArchivedApplicationsTeamsite,
        emailedApplications: NDEmailedApplicationsTeamsite
      };
    } else {
      console.warn('Where is the teamsite?!');
    }
    this.configureDisplays();
    this.configureDisplayBasedOnUser();
  }

  configureDisplayBasedOnUser() {
    const userInfoState: UserInfoStateStructure
      = this.reducerUtilityService.getApplicationStates()[LOGIN_INFO_REDUCER_NAME];
    if (!(
      userInfoState.userInfo.ffmId
      || userInfoState.basicUserInfo.userType.toUpperCase() === USER_ROLE.AGENCY_ADMIN.toUpperCase()
      || userInfoState.basicUserInfo.userType.toUpperCase() === USER_ROLE.INTERNAL.toUpperCase()
    )) {
      // if user is an agent without ffm ID, disable some stuff
      this.disableButtons = true;
    }
  }

  configureDisplays() {
    switch (this.prospect.status.id) {
      case 2: // Emailed Application - // "#!/marketplace/payment/options";
        this.buttonVisibility.summary = true;
        break;
      case 6: // "New Customer"
        this.buttonVisibility.editInfo = true;
        this.buttonVisibility.goToMarketplace = true;
        this.exchangeStatusNextSteps = this.teamsite.inProgressApplications.newCustomerStatusMessage;
        break;
      case 7: // 'Eligibility Exception'
        this.buttonVisibility.goToMarketplace = true;
        this.exchangeStatusNextSteps = this.teamsite.inProgressApplications.eligibilityMessage;
        break;
      case 8: // 'User-Initiated Return'
        this.buttonVisibility.goToMarketplace = true;
        this.exchangeStatusNextSteps = this.teamsite.inProgressApplications.userInitiatedReturnMessage;
        break;
      case 9: // 'Eligibility Complete'
        this.buttonVisibility.goToEligibilityStatus = true;
        this.exchangeStatusNextSteps = this.teamsite.inProgressApplications.EligibilityCompleteMessage;
        break;
      case 11: // 'Enrollment Submission Failed'
        this.exchangeStatusNextSteps = this.teamsite.inProgressApplications.enrollmentSubmissionFailMessage;
        break;
      case 12:
      case 14: // Submitted without Payment
        this.buttonVisibility.summary = true;
        this.buttonVisibility.moreInfo = true;
        this.buttonVisibility.expire = true;

        const today = new Date();
        let applicationEffectiveDate = null;
        if ((this.prospect as any).fullData?.appdata && (this.prospect as any).fullData?.appdata?.effectiveDate) {
          applicationEffectiveDate = new Date((this.prospect as any).fullData.appdata.effectiveDate);
          console.log('effectiveDateOrig::', (this.prospect as any).fullData.appdata.effectiveDate);
        } else {
          console.log('no appData');
        }

        if (applicationEffectiveDate && today < applicationEffectiveDate) {
          this.buttonVisibility.makePayment = true;
          this.exchangeStatusNextSteps = this.teamsite.completedApplications.appSubmitSuccessMessage;
        } else {
          this.exchangeStatusNextSteps = this.teamsite.completedApplications.noPaymentSubmitMessage;
        }

        break;
      case 13: // Submitted with Payment
        this.buttonVisibility.summary = true;
        this.buttonVisibility.expire = true;
        this.exchangeStatusNextSteps = this.teamsite.completedApplications.submitWithPaymentMessage;
        break;
      case 15: // 'Payment past due Submitted Apps'
        this.showPaymentInfo = true;
        this.buttonVisibility.moreInfo = true;
        this.exchangeStatusNextSteps = this.teamsite.inProgressApplications.paymentPastDueMessage;
        break;
      case 16: // 'Payment past due SMAB'
        this.buttonVisibility.goToReviewPage = true;
        this.showPaymentInfo = true;
        this.exchangeStatusNextSteps = this.teamsite.inProgressApplications.paymentPastDueSMABMessage;
        break;
      case 18: //"Deleted"
        break;
    }
  }
  goToEditInfo() {
    // @TODO
    throw new Error('not implemented');
  }
  async goToViewResults(event) {
    await this.prospectService.configureBrandingFromProspectResponse(this.prospect);
    this.viewResults.next(event);
  }
  async goToMarketplace() {

    const userInfoState: UserInfoStateStructure
      = this.reducerUtilityService.getApplicationStates()[LOGIN_INFO_REDUCER_NAME];

    await this.prospectService.configureBrandingFromProspectResponse(this.prospect);

    this.ffmRedirectService.redirectToFFM({
      userType: 'Agent',
      state: this.prospect.state,
      ffmAssignedConsumerID: null, // applicants[0].FFEUserId - might be something from eligibility, we don't have this value here
      partnerAssignedConsumerID: this.prospect.prospectId,
      firstName: this.prospect.firstName,
      middleName: null,
      lastName: this.prospect.lastName,
      address1: this.prospect.address1,
      address2: this.prospect.address2,
      dob: this.prospect.dob,
      city: this.prospect.city,
      ffmId: userInfoState.userInfo.ffmId,
      npnNo: userInfoState.userInfo.npnNo
    });
  }
  goToPaymentFlow(event) {
    this.makePayment.next(event);
  }
  showMoreInfo() {
    this.moreInfo.next(this.teamsite.inProgressApplications.paymentStatusModal);
  }
  expireApp(event) {
    this.expire.next(event);
  }
}
